import classNames from 'classnames';
import React from 'react';
import { errorIcon, closeGreyLightIcon } from './assets';
import style from './style.module.scss';
import type { IProps } from './types';

export const ErrorMessage = ({
  hasBackground,
  className,
  hasIcon,
  icon,
  errorMessage,
  isCloseButton = false,
  onClick,
}: IProps): React.JSX.Element => (
  <div
    className={classNames(
      style.errorMessageWrapper,
      hasBackground ? style.hasBackgroundError : '',
      className,
    )}
  >
    {hasIcon && (
      <div className={style.errorMessageIconWrapper}>
        <img
          width={16}
          height={20}
          className={classNames(style.errorMessageIcon)}
          alt=""
          src={icon || errorIcon}
        />
      </div>
    )}
    <p className={style.errorMessageText}>{errorMessage}</p>
    {isCloseButton && (
      <div className={style.errorMessageButton} onClick={onClick} aria-hidden>
        <img width={14} height={14} alt="" src={closeGreyLightIcon} />
      </div>
    )}
  </div>
);

export default ErrorMessage;
